var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9997 29.3327C12.9108 28.5549 10.3608 26.7827 8.34967 24.016C6.33856 21.2493 5.33301 18.1771 5.33301 14.7993V6.66602L15.9997 2.66602L26.6663 6.66602V14.7993C26.6663 18.1771 25.6608 21.2493 23.6497 24.016C21.6386 26.7827 19.0886 28.5549 15.9997 29.3327ZM15.9997 26.5327C18.1552 25.866 19.9552 24.5493 21.3997 22.5827C22.8441 20.616 23.6886 18.4216 23.933 15.9993H15.9997V5.49935L7.99967 8.49935V15.3993C7.99967 15.5549 8.0219 15.7549 8.06634 15.9993H15.9997V26.5327Z",
    fill: "#03C988"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security-icon.966313640e21501f94162f31c03cb63e.svg";
export { ForwardRef as ReactComponent };